import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTi = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M12 4.5C12.0037 3.87437 11.7727 3.2701 11.3526 2.80649C10.9325 2.34288 10.3539 2.05363 9.73091 1.99586C9.10796 1.93808 8.48598 2.11598 7.98779 2.49443C7.4896 2.87288 7.15141 3.42436 7.04001 4.04C6.71036 4.10176 6.39651 4.22921 6.11714 4.41478C5.83777 4.60034 5.5986 4.84022 5.41385 5.12014C5.22911 5.40005 5.10258 5.71427 5.04179 6.0441C4.981 6.37393 4.98719 6.71261 5.06001 7.04C4.60867 7.12012 4.18805 7.32279 3.84413 7.62586C3.50021 7.92892 3.24624 8.32071 3.10999 8.75839C2.97373 9.19606 2.96043 9.66278 3.07154 10.1075C3.18266 10.5522 3.41391 10.9578 3.74001 11.28C3.19154 11.5332 2.73229 11.9461 2.42237 12.4646C2.11245 12.9832 1.9663 13.5832 2.00304 14.1862C2.03978 14.7892 2.2577 15.367 2.62829 15.8441C2.99887 16.3212 3.50485 16.6752 4.08001 16.86C3.97019 17.2748 3.96901 17.711 4.07659 18.1264C4.18417 18.5419 4.39687 18.9226 4.69423 19.232C4.9916 19.5415 5.3636 19.7691 5.77444 19.8931C6.18528 20.0171 6.62112 20.0332 7.04001 19.94C7.14381 20.5119 7.44364 21.0297 7.88792 21.4045C8.33219 21.7792 8.89316 21.9874 9.47435 21.9934C10.0555 21.9993 10.6206 21.8025 11.0724 21.4369C11.5243 21.0713 11.8346 20.5596 11.95 19.99L12 20V4.5Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M16 8V5C16 3.9 16.9 3 18 3",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M12 13H16",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M12 18H18C18.5304 18 19.0391 18.2107 19.4142 18.5858C19.7893 18.9609 20 19.4696 20 20V21",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M12 8H20",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M20.5 8C20.5 8.13261 20.4473 8.25979 20.3536 8.35355C20.2598 8.44732 20.1326 8.5 20 8.5C19.8674 8.5 19.7402 8.44732 19.6464 8.35355C19.5527 8.25979 19.5 8.13261 19.5 8C19.5 7.86739 19.5527 7.74021 19.6464 7.64645C19.7402 7.55268 19.8674 7.5 20 7.5C20.1326 7.5 20.2598 7.55268 20.3536 7.64645C20.4473 7.74021 20.5 7.86739 20.5 8Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_7",
				d: "M16.5 13C16.5 13.1326 16.4473 13.2598 16.3536 13.3536C16.2598 13.4473 16.1326 13.5 16 13.5C15.8674 13.5 15.7402 13.4473 15.6464 13.3536C15.5527 13.2598 15.5 13.1326 15.5 13C15.5 12.8674 15.5527 12.7402 15.6464 12.6464C15.7402 12.5527 15.8674 12.5 16 12.5C16.1326 12.5 16.2598 12.5527 16.3536 12.6464C16.4473 12.7402 16.5 12.8674 16.5 13Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_8",
				d: "M20.5 21C20.5 21.1326 20.4473 21.2598 20.3536 21.3536C20.2598 21.4473 20.1326 21.5 20 21.5C19.8674 21.5 19.7402 21.4473 19.6464 21.3536C19.5527 21.2598 19.5 21.1326 19.5 21C19.5 20.8674 19.5527 20.7402 19.6464 20.6464C19.7402 20.5527 19.8674 20.5 20 20.5C20.1326 20.5 20.2598 20.5527 20.3536 20.6464C20.4473 20.7402 20.5 20.8674 20.5 21Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_9",
				d: "M18.5 3C18.5 3.13261 18.4473 3.25979 18.3536 3.35355C18.2598 3.44732 18.1326 3.5 18 3.5C17.8674 3.5 17.7402 3.44732 17.6464 3.35355C17.5527 3.25979 17.5 3.13261 17.5 3C17.5 2.86739 17.5527 2.74021 17.6464 2.64645C17.7402 2.55268 17.8674 2.5 18 2.5C18.1326 2.5 18.2598 2.55268 18.3536 2.64645C18.4473 2.74021 18.5 2.86739 18.5 3Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgTi;
